<template>
  <v-container fluid>
    <h2 class="page-title mb-1">Herramientas Internas</h2>
    <p class="page-desc mb-4">
      Herramientas de uso interno para QA y validación de integraciones durante el
      desarrollo.
    </p>

    <RangerTestChat api-endpoint="/internal/ranger/test-chat" />
  </v-container>
</template>

<script>
import RangerTestChat from '@/components/RangerTestChat.vue';

export default {
  name: 'InternalTools',
  components: { RangerTestChat }
};
</script>

<style scoped>
.page-title {
  color: var(--pw-primary);
  font-weight: 700;
}
.page-desc {
  font-size: 13px;
  color: var(--pw-text-muted);
  max-width: 760px;
}
</style>
